import type { Asset } from "@storytell/types";
import {
  FaSolidFileAudio,
  FaSolidFileCsv,
  FaSolidFileExcel,
  FaSolidFileImage,
  FaSolidFilePdf,
  FaSolidFileVideo,
} from "solid-icons/fa";
import { TbFileText, TbPdf } from "solid-icons/tb";

export const getAssetIcon = (asset: Pick<Asset, "filename">) => {
  const extension = asset.filename.split(".").pop()?.toLowerCase();
  switch (extension) {
    case "pdf":
      return FaSolidFilePdf;
    case "csv":
      return FaSolidFileCsv;
    case "xlsx":
    case "xls":
      return FaSolidFileExcel;
    case "png":
    case "jpg":
    case "jpeg":
    case "gif":
    case "bmp":
    case "svg":
      return FaSolidFileImage;
    case "mp3":
    case "m4a":
    case "wav":
    case "ogg":
    case "opus":
    case "flac":
    case "m4b":
    case "aiff":
    case "au":
      return FaSolidFileAudio;
    case "mp4":
    case "mov":
    case "avi":
    case "flv":
    case "3gp":
    case "m4v":
    case "ogm":
    case "ogv":
    case "qt":
    case "webm":
      return FaSolidFileVideo;
    default:
      return TbFileText;
  }
};
